



















































































import Vue, { PropType } from 'vue';
import { MountingPortal } from 'portal-vue';
import clickoutside from '@/directives/clickoutside';
import SvgIcon from '@/components/SvgIcon';
import { isMobile } from '@/utils/isMobile';
import { SelectOption, SelectOptions } from './types';

export default Vue.extend({
    name: 'Select',

    model: {
        prop: 'value',
        event: 'change',
    },

    components: { MountingPortal, SvgIcon },

    props: {
        disabled: Boolean,
        name: String,
        value: [String, Number, Object],
        options: {
            type: Array as PropType<SelectOptions>,
        },
        placeholder: String,
        dropdownAppendToBody: { type: Boolean, default: true },
    },

    data() {
        return {
            isMobile: isMobile(),
            showDropdown: false,
            focused: false,
        };
    },

    created() {
        if (this.dropdownAppendToBody) {
            const portal = document.createElement('div');
            portal.id = 'select' + (this as any)._uid;
            document.body.appendChild(portal);
            (this as any).portal = portal;

            window.addEventListener('resize', this.handleResize);
        }
    },

    beforeDestroy() {
        if (this.dropdownAppendToBody) {
            window.removeEventListener('resize', this.handleResize);
        }
    },

    computed: {
        label(): string | undefined {
            const selectedOption = this.options?.find(
                (option) => option.value == this.value
            );

            return selectedOption?.label;
        },
    },

    methods: {
        async onClickOutside(event: Event) {
            await this.$nextTick();

            if (this.$el.contains(event.target as Node)) {
                return;
            }

            if (this.showDropdown) {
                this.showDropdown = false;
            }
        },

        onOptionClick(option: SelectOption) {
            if (this.value != option.value) {
                this.$emit('change', option.value);
            }

            this.showDropdown = false;
        },

        async setDropdownPosition() {
            if (!this.dropdownAppendToBody) {
                return;
            }
            await this.$nextTick();
            const dropdown = this.$refs.dropdown as HTMLElement;
            const display = this.$refs.display as HTMLElement;
            const rect = display.getBoundingClientRect();

            if (!dropdown) {
                return;
            }

            dropdown.style.top = rect.top + rect.height + window.pageYOffset + 'px';
            dropdown.style.left = rect.left + 'px';
            dropdown.style.width = rect.width + 'px';
        },

        handleResize() {
            if (this.showDropdown) {
                this.setDropdownPosition();
            }
        },
    },

    watch: {
        showDropdown(value) {
            if (value) {
                this.setDropdownPosition();
            }
        },
    },

    directives: { clickoutside },
});
